import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

// SIGNIN

function* signinUser(formData) {
  try {
    yield put(actions.setAuthIsLoadingAction(true));
    const result = yield call(api.Login, formData.payload);
    if (result.data.errors) {
      toast.error(result.data.errors[0]);
    } else {
      yield put(
        actions.loginUserSuccessAction({
          data: result.data,
        })
      );
      console.log(result);
      result.data.data.role[0].name == "Super Admin" &&
        window.location.replace("/dashboard/superadmin-teachers");
      result.data.data.role[0].name == "Teacher" &&
        window.location.replace("/dashboard/students");
      result.data.data.role[0].name == "Student" &&
        window.location.replace("/home");
    }
  } catch (error) {
    console.log(error.response);
    if (error?.response?.data.data?.is_approved == 0) {
      window.localStorage.setItem(
        "userID",
        error?.response?.data?.data.user_id
      );
      window.location.replace("/otp");
    }

    toast.error(error.response.data.errors.join(","));
  } finally {
    yield put(actions.setAuthIsLoadingAction(false));
  }
}

function* registerUser(formData) {
  try {
    yield put(actions.setAuthIsLoadingAction(true));
    const result = yield call(api.Register, formData.payload);
    yield put(actions.registerUserSuccessAction(result.data));
  } catch (error) {
    toast.error(Object.values(error.response.data.errors)?.join(","));
  } finally {
    yield put(actions.setAuthIsLoadingAction(false));
  }
}

function* forgetpasswordUser(formData) {
  try {
    yield put(actions.setAuthIsLoadingAction(true));
    const result = yield call(api.Forgetpassword, formData.payload);
    console.log(result.data);
    yield put(actions.ForgetpasswordSuccessAction(result.data));
  } catch (error) {
    toast.error(Object.values(error.response.data.errors)?.join(","));
  } finally {
    yield put(actions.setAuthIsLoadingAction(false));
  }
}

function* forgetpasswordOtpUser(formData) {
  try {
    yield put(actions.setAuthIsLoadingAction(true));
    const result = yield call(api.ForgetpasswordOtp, formData.payload);
    if (result.data.errors) {
      toast.error(result.data.errors[0]);
    } else {
      yield put(
        actions.forgetpasswordOtpUserSuccessAction({
          data: result.data,
        })
      );
    }
  } catch (error) {
    toast.error(" حاول مرة تانية");
  } finally {
    yield put(actions.setAuthIsLoadingAction(false));
  }
}

function* resetPassword(formData) {
  try {
    yield put(actions.setAuthIsLoadingAction(true));
    const result = yield call(api.Resetpassword, formData.payload);
    yield put(actions.ResetpasswordSuccessAction(result.data));
  } catch (error) {
    toast.error(Object.values(error.response.data.errors)?.join(","));
  } finally {
    yield put(actions.setAuthIsLoadingAction(false));
  }
}

function* otpUser(formData) {
  try {
    yield put(actions.setAuthIsLoadingAction(true));
    const result = yield call(api.Otp, formData.payload);
    toast.success(" تم التسجيل بنجاح و سيتم مراجعة بياناتك");

    if (result.data.errors) {
      toast.error(result.data.errors[0]);
    } else {
      yield put(
        actions.otpUserSuccessAction({
          data: result.data,
        })
      );
    }
    window.location.replace("/login");
  } catch (error) {
    toast.error(" حاول مرة تانية");
  } finally {
    yield put(actions.setAuthIsLoadingAction(false));
  }
}

function* resendOtpUser(formData) {
  try {
    // yield put(actions.setAuthIsLoadingAction(true));
    const result = yield call(api.ResendOtp, formData.payload);
    toast.success("تم ارسال الكود");
    if (result.data.errors) {
      toast.error(result.data.errors[0]);
    } else {
      yield put(
        actions.resendOtpUserSuccessAction({
          data: result.data,
        })
      );
    }
  } catch (error) {
    toast.error(" حاول مرة تانية");
  } finally {
    yield put(actions.setAuthIsLoadingAction(false));
  }
}

function* getSystemGovernment({ payload }) {
  try {
    const result = yield call(api.getSystemGovernment);
    yield put(actions.getSystemGovernmentSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getSystemGovernmentFail());
  } finally {
  }
}

function* getSystemRegions({ payload }) {
  try {
    const result = yield call(api.getSystemRegion, payload);
    yield put(actions.getSystemRegionSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getSystemRegionFail());
  } finally {
  }
}

function* getSystemGrades({ payload }) {
  try {
    const result = yield call(api.getSystemGrades);
    yield put(actions.getSystemGradesSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getSystemGradesFail());
  } finally {
  }
}

function* getSystemMajors({ payload }) {
  try {
    const result = yield call(api.getSystemMajors);
    yield put(actions.getSystemMajorsSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getSystemMajorsFail());
  } finally {
  }
}

function* signoutUser() {
  try {
    yield put(actions.setAuthIsLoadingAction(true));
    // yield call(api.Logout);
    window.localStorage.clear();

    window.location.href = "/";
  } catch (error) {
    const { response, message } = error;
  } finally {
    yield put(actions.setAuthIsLoadingAction(false));
  }
}

function* userVoucher({ payload }) {
  try {
    yield put(actions.setAuthIsLoadingAction(true));
    const result = yield call(api.userVoucher, payload?.formData);
    yield put(actions.userVoucherSuccessAction());
    payload?.action && payload?.action();
  } catch (error) {
    toast.error("طلبك  مرفوض");
    const { response, message } = error;
  } finally {
    yield put(actions.setAuthIsLoadingAction(false));
  }
}

export default function* authSaga() {
  yield takeLatest(Types.LOGIN_USER, signinUser);
  yield takeLatest(Types.REGISTER_USER, registerUser);
  yield takeLatest(Types.FORGET_PASSWORD, forgetpasswordUser);
  yield takeLatest(Types.FORGET_PASSWORD_OTP_USER, forgetpasswordOtpUser);
  yield takeLatest(Types.RESET_PASSWORD, resetPassword);

  yield takeLatest(Types.OTP_USER, otpUser);
  yield takeLatest(Types.RESEND_OTP_USER, resendOtpUser);

  yield takeLatest(Types.LOGOUT_USER, signoutUser);
  yield takeLatest(Types.USER_VOUCHER, userVoucher);
  yield takeLatest(Types.GET_SYSTEM_GOVERNMENT_REQUEST, getSystemGovernment);
  yield takeLatest(Types.GET_SYSTEM_GRADES_REQUEST, getSystemGrades);
  yield takeLatest(Types.GET_SYSTEM_REGION_REQUEST, getSystemRegions);
  yield takeLatest(Types.GET_SYSTEM_MAJORS_REQUEST, getSystemMajors);
}
